'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ButtonContextProvider: function() {
        return ButtonContextProvider;
    },
    useButtonContext: function() {
        return useButtonContext;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const buttonContext = /*#__PURE__*/ _react.createContext(undefined);
const buttonContextDefaultValue = {};
const ButtonContextProvider = buttonContext.Provider;
const useButtonContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(buttonContext)) !== null && _React_useContext !== void 0 ? _React_useContext : buttonContextDefaultValue;
};
